import { useState } from 'react';
import MonacoJsonEditor from './MonacoJsonEditor';

const JsonPreview = ({ jsonInput, setJsonInput, cookieConsent }) => {

    const [expandedBlocks, setExpandedBlocks] = useState(new Set());

  const toggleBlock = (index) => {
    const newExpanded = new Set(expandedBlocks);
    if (newExpanded.has(index)) {
      newExpanded.delete(index);
    } else {
      newExpanded.add(index);
    }
    setExpandedBlocks(newExpanded);
  };

  const updateJsonAtIndex = (index, value) => {
    try {
      const newParsedJson = [...JSON.parse(jsonInput)];
      if (value === '') {
        newParsedJson.splice(index, 1);
      } else {
        newParsedJson[index] = JSON.parse(value);
      }
      setJsonInput(JSON.stringify(newParsedJson, null, 2));
    } catch (error) {
      // バリデーションエラー時は更新しない
      console.log('error', error);
    }
  };

  const deleteBlock = (index) => {
    const newParsedJson = [...JSON.parse(jsonInput)];
    newParsedJson.splice(index, 1);
    setJsonInput(JSON.stringify(newParsedJson, null, 2));
  };


    const styles = {
        previewContainer: {
            width: "95%",
            maxWidth: "97%",
            margin: "20px auto",
            borderRadius: "10px",
            boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.3)",
            padding: "15px",
            '@media (maxWidth: 768px)': {
                padding: "10px",
                fontSize: "14px",
            }
        },
        block: {
            padding: "10px",
            margin: "10px 0",
            borderRadius: "5px",
            border: "1px solid #e0e0e0",
        },
        blockHeader: {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
            justifyContent: 'space-between',
        },
        blockHeaderContent: {
            display: 'flex',
            alignItems: 'center',
        },
        toggleButton: {
            background: "none",
            border: "none",
            color: "#32bc9b",
            cursor: "pointer",
            fontSize: "16px",
        },
        deleteButton: {
            fontSize: '16px',
            padding: '5px 10px',
            color: '#32bc9b',
            cursor: 'pointer',
            width: '100px',
            alignSelf: 'center',
            background: 'none',
            border: '1px solid #32bc9b',
            borderRadius: '5px',
        },
    }

  return (
    <>
      <h2>プレビュー</h2>
      <div style={styles.previewContainer}>
            {JSON.parse(jsonInput).map((item, index) => (
              <div key={`${JSON.stringify(item)}-${index}-${crypto.randomUUID()}`} data-swapy-slot={`${JSON.stringify(item)}-${index}`}>
                <div data-swapy-item={`${JSON.stringify(item)}-${index}`} style={styles.block}>
                <div style={styles.blockHeader}>
                  <div
                    style={styles.blockHeaderContent}
                    onClick={() => toggleBlock(index)}
                  >
                    <button style={styles.toggleButton} disabled={cookieConsent !== 'accepted'}>
                      {expandedBlocks.has(index) ? '▼' : '▶'}
                    </button>
                    <span>要素 {index + 1}</span>
                  </div>
                  {!expandedBlocks.has(index) && (
                    <button
                      onClick={() => deleteBlock(index)}
                      style={styles.deleteButton}
                      disabled={cookieConsent !== 'accepted'}
                    >
                      削除
                    </button>
                  )}
                </div>
                {expandedBlocks.has(index) && (
                  <MonacoJsonEditor
                    val={JSON.stringify(item, null, 2)}
                    onChange={(value) => updateJsonAtIndex(index, value)}
                    style={styles.textarea}
                    disabled={cookieConsent !== 'accepted'}
                    isBlock={true}
                    />
                  )}
                </div>
              </div>
            ))}
      </div>
    </>
  );
};

export default JsonPreview;
